import React, { useState, useEffect } from "react";
import {
  Button,
  Icon,
  AppBar,
  Toolbar,
  Typography,
  Box,
  Grid2,
  Link,
} from "@mui/material";
import { Outlet } from "react-router-dom";
import { GlobalState, Rental } from "store/rentals-store";
import { useSelector } from "react-redux";
import PurchaseSummary from "components/organisms/purchase-summary/purchase-summary";
import ActionButton from "components/atoms/action-button/action-button";
import ErrorModalComponent from "components/molecules/error-modal/error-modal";
import StepsBreadcrumb from "components/molecules/breadcrumb/steps-breadcrumb";
import { Path } from "components/app.component";
import "./header-summary.css";

export default function HeaderSummary() {
  const [displaySummary, setDisplaySummary] = useState(false);
  const path: string = useSelector(
    (state: GlobalState) => state.navigation.currentPath
  );
  const rental: Rental = useSelector((state: GlobalState) => state.rental);

  useEffect(() => {
    setDisplaySummary(false);
  }, [path]);

  useEffect(() => {
    if (rental.totals?.items.length === 0) {
      setDisplaySummary(false);
    }
  }, [rental]);

  return (
    <Grid2 container>
      <ErrorModalComponent></ErrorModalComponent>
      <AppBar position="static">
        <Toolbar>
          <Typography
            variant="h6"
            color={"white"}
            component="div"
            sx={{ flexGrow: 1 }}
          >
            <Link href="/" color="inherit" underline="none">
              Rentadora Mérida
            </Link>
          </Typography>
          <Box sx={{ display: { md: "none", xs: "block" } }}>
            {displaySummary ? (
              <Button
                sx={{ zIndex: 2 }}
                data-testid="close-summary-top"
                onClick={() => setDisplaySummary(false)}
              >
                <Icon sx={{ color: "inherit" }}>close</Icon>
              </Button>
            ) : (
              <Button
                data-testid="open-summary-top"
                onClick={() => setDisplaySummary(true)}
              >
                <Icon sx={{ color: "white" }}>directions_car</Icon>
                {rental.totals && (
                  <sup key="counter">{rental.totals.items.length}</sup>
                )}
              </Button>
            )}
          </Box>
        </Toolbar>
      </AppBar>
      <Grid2 size={{ xl: 9, lg: 9, md: 9, sm: 12, xs: 12 }} padding={"2%"}>
        {path && path !== Path.Home && path !== Path.Confirmation && (
          <StepsBreadcrumb></StepsBreadcrumb>
        )}
        <Outlet />
      </Grid2>
      <Grid2
        size={{ xl: 3, lg: 3, md: 3, sm: 12, xs: 12 }}
        className={
          "purchase-container " + (displaySummary ? "show-summary" : "")
        }
      >
        <PurchaseSummary />
      </Grid2>
      <Box
        className="continue-bottom"
        sx={{ zIndex: 2, display: { md: "none", xs: "block" } }}
      >
        <ActionButton className="continue-bottom" />
      </Box>
    </Grid2>
  );
}
